import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey = 'brand_tile-header-action_category_impression';

/**
 * An event for when a brand header is viewed. A brand header differs from a brand tile in that it consists of a header featuring the brand's name, with the brand's product below the header.

Parameters:
- requestId: BE-generated request id
- impressionId: BE-generated impression id
- brand token
- surfaceContext: ProductTileScreen enum
- containerContext: ProductTileScreenContainer enum
- token: page specific identifier
- dwellTime
- maxVisibilityPercent
 */
export function trackBrandTileHeaderActionCategoryImpression(
  requestId: string,
  impressionId2: string,
  brandToken: string,
  surfaceContext3: string,
  containerContext4: string,
  token5: string,
  dwellTime6: string,
  maxVisibilityPercent7: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: {
      requestId,
      impressionId2,
      brandToken,
      surfaceContext3,
      containerContext4,
      token5,
      dwellTime6,
      maxVisibilityPercent7,
    },
  });
}
